import { useGetInformacoesAgendamento } from "hooks/gestaoCobranca/useGetInformacoesAgendamento";
import { DashBox } from "shared/components/dashbox/DashBox";

export const BoxInformativosAgendamento: React.FC = () => {
  const { data: informacoesAgendamento } = useGetInformacoesAgendamento();

  return (
    <div className="d-flex justify-content-around">
      <DashBox
        conteudo={informacoesAgendamento?.totalAgendado}
        titulo="Todos os agendamentos"
        cor="#000"
        key={"abaAgendamento-todosOsContatos"}
      />
      <DashBox
        conteudo={informacoesAgendamento?.totalAgendadoParaOsProximos7Dias}
        titulo="Contatos para os próximos 7 dias"
        cor="#ed8f37"
        key={"abaAgendamento-proximos7Dias"}
      />
      <DashBox
        conteudo={informacoesAgendamento?.totalAgendadoHoje}
        titulo="Contatos para hoje"
        cor="#f5b93d"
        key={"abaAgendamento-contatosParaHoje"}
      />
      <DashBox
        conteudo={informacoesAgendamento?.totalAtrasado}
        titulo="Contatos atrasados"
        cor="#e8654a"
        key={"abaAgendamento-contatosAtrasados"}
      />
    </div>
  );
};
